import { InjectionToken } from '@angular/core';
import { ChatComponent } from '../_shared/chat-types';

export const WASHING_MACHINE = new InjectionToken<ChatComponent>(
  'WASHING_MACHINE'
);
